import React from 'react';
import { EntityListBuilder } from '../../../../shared/lib/entityListBuilder';
import {
  modalActionTypes,
  modalTypes,
} from '../../../../shared/lib/toggleModalVisble';
import {
  ShutdownAlisaTextActions,
  ShutdownAlisaTextContent,
} from '../../../../features/shutdown/changeAlisaText';
import { ShutdownAddressesContent } from '../../../../features/shutdown/changeAddresses';
import { ShutdownNotifyToContent } from '../../../../features/shutdown/changeNotifyTo';
import styles from './ExpandedRow.module.scss';

const classNames = {
  card: styles.card,
  btn: styles.cardBtn,
  title: styles.cardTitle,
};

const onClick =
  ({ dispatch, payload }) =>
  () => {
    dispatch({
      type: modalActionTypes.setModalData,
      payload,
    });
  };

const hasAddresses = (shutdown) => {
  const {
    serviceCompany = null,
    houseIds = [],
    addressIds = [],
  } = shutdown.alertAddresses || {};

  return !!serviceCompany?.id || houseIds?.length > 0 || addressIds?.length > 0;
};

const cardRenders = {
  alisaText: ({ shutdown, dispatch }) => {
    const data = {
      title: 'Текст автоответа',
      classNames,
      action: shutdown.alisaText?.trim() ? (
        <ShutdownAlisaTextActions shutdown={shutdown} />
      ) : null,
      bodyContent: shutdown.alisaText?.trim() ? (
        <ShutdownAlisaTextContent alisaText={shutdown.alisaText} />
      ) : null,
    };

    if (dispatch) {
      data.btnProps = {
        text: shutdown.alisaText?.trim() ? 'Изменить' : 'Добавить',
        onClick: onClick({
          dispatch,
          payload: {
            type: modalTypes.changeShutdownAlisaText,
            initialValues: shutdown,
          },
        }),
      };
    }

    return data;
  },

  addresses: ({ shutdown, dispatch }) => {
    const data = {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 10,
          }}
        >
          <span>{`УК и адреса${
            shutdown?.alertCity?.name ? ` (${shutdown.alertCity.name})` : ''
          }`}</span>
          {!!shutdown?.flatCount && (
            <span>{`Количество помещений: ${shutdown?.flatCount}`}</span>
          )}
        </div>
      ),
      classNames,
      bodyContent: hasAddresses(shutdown) ? (
        <ShutdownAddressesContent shutdown={shutdown} />
      ) : null,
    };

    if (dispatch) {
      data.btnProps = {
        text: 'Изменить',
        onClick: onClick({
          dispatch,
          payload: {
            type: modalTypes.changeShutdownAddresses,
            initialValues: shutdown,
          },
        }),
      };
    }

    return data;
  },

  notifyTo: ({ shutdown, dispatch }) => {
    const data = {
      title: 'Уведомления отправлены',
      classNames,
      bodyContent: Boolean(shutdown.notifyTo?.length) ? (
        <ShutdownNotifyToContent shutdown={shutdown} />
      ) : null,
    };

    if (dispatch) {
      data.btnProps = {
        text: shutdown.notifyTo?.length ? 'Изменить' : 'Добавить',
        onClick: onClick({
          dispatch,
          payload: {
            type: modalTypes.changeShutdownNotifyTo,
            initialValues: shutdown,
          },
        }),
      };
    }

    return data;
  },
};

export const createCards = (data) => {
  const { alisaText, addresses, notifyTo } = cardRenders;

  const cards = new EntityListBuilder();

  cards
    .addItem(alisaText(data))
    .addItem(addresses(data))
    .addItem(notifyTo(data));

  return cards.getList();
};
